/**
 * Generated from ch6_p03.fla
 */
export function ch6_p03(this: Ich6_p03) {
	const rain = this.rain;
	if (!rain[0] && rain.elementFactory) {
		rain[0] = rain.elementFactory(0,undefined);
	}
	if (rain[0]) {
		ch6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain2.call(rain[0] as Ich6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain2);
		rain[0].x = 820.5;
		rain[0].y = 384;
		rain[0].width = 1641.00;
		rain[0].height = 768.00;
		rain[0].alpha = 1;
		if (rain[0].onLayout) rain[0].onLayout();
	}
	if (!rain[1] && rain.elementFactory) {
		rain[1] = rain.elementFactory(1,undefined);
	}
	if (rain[1]) {
		ch6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain1.call(rain[1] as Ich6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain1);
		rain[1].x = 813.75;
		rain[1].y = 388.5;
		rain[1].width = 1600.50;
		rain[1].height = 759.00;
		rain[1].alpha = 1;
		if (rain[1].onLayout) rain[1].onLayout();
	}
	const bg = this.bg;
	ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const horse = this.horse;
	ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_horse.call(this.horse);
	horse.x = 679.75;
	horse.y = 768;
	horse.width = 609.50;
	horse.height = 714.00;
	horse.alpha = 1.00;
	if (horse.onLayout) horse.onLayout();
	const holly = this.holly;
	ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_holly.call(this.holly);
	holly.x = 821.75;
	holly.y = 768;
	holly.width = 244.50;
	holly.height = 595.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const tyler = this.tyler;
	ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_tyler.call(this.tyler);
	tyler.x = 1107.75;
	tyler.y = 768;
	tyler.width = 364.50;
	tyler.height = 683.50;
	tyler.alpha = 1.00;
	if (tyler.onLayout) tyler.onLayout();
	const frameRight = this.frameRight;
	ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeRlineart.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 601;
	linesRight.width = 92.50;
	linesRight.height = 322.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeLlineart.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 657.25;
	linesLeft.width = 126.50;
	linesLeft.height = 218.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_bg(this: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p03_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_horse(this: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p03_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_holly(this: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p03_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_tyler(this: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p03_tyler", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain2(this: Ich6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain2) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain1(this: Ich6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain1) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeRframe(this: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeRlineart(this: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeRlineart) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rlineart", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
function ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeLframe(this: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeLlineart(this: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeLlineart) {
	if (this.setLayoutTexture) this.setLayoutTexture("Llineart", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich6_p03Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p03Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p03Sprite extends Ich6_p03Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p03Text extends Ich6_p03Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p03Polygon extends Array<number> {
}
interface Ich6_p03 {
	readonly rain: Ich6_p03Array<Ich6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain2|Ich6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain1>;
	readonly bg: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_bg;
	readonly horse: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_horse;
	readonly holly: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_holly;
	readonly tyler: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_tyler;
	readonly frameRight: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeRframe;
	readonly linesRight: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeRlineart;
	readonly frameLeft: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeLframe;
	readonly linesLeft: Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeLlineart;
}
interface Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_bg extends Ich6_p03Sprite {
}
interface Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_horse extends Ich6_p03Sprite {
}
interface Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_holly extends Ich6_p03Sprite {
}
interface Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_tyler extends Ich6_p03Sprite {
}
interface Ich6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain2 extends Ich6_p03Sprite {
}
interface Ich6_p03_hh_ch6_72dpi_p03psdAssetrainoverlayrain1 extends Ich6_p03Sprite {
}
interface Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeRframe extends Ich6_p03Sprite {
}
interface Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeRlineart extends Ich6_p03Sprite {
}
interface Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeLframe extends Ich6_p03Sprite {
}
interface Ich6_p03_hh_ch6_72dpi_p03psdAssetchp6_p03_wcframeLlineart extends Ich6_p03Sprite {
}
